/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface SetRolesDto
 */
export interface SetRolesDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof SetRolesDto
     */
    selectedRoles: Set<string>;
    /**
     * 
     * @type {UserIdDto}
     * @memberof SetRolesDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the SetRolesDto interface.
 */
export function instanceOfSetRolesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "selectedRoles" in value;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function SetRolesDtoFromJSON(json: any): SetRolesDto {
    return SetRolesDtoFromJSONTyped(json, false);
}

export function SetRolesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRolesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selectedRoles': json['selectedRoles'],
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function SetRolesDtoToJSON(value?: SetRolesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selectedRoles': Array.from(value.selectedRoles as Set<any>),
        'userId': UserIdDtoToJSON(value.userId),
    };
}

